import { createRefluxStore } from 'Util/refluxConnector';

class AppState {
  static state = {
    mainMenuOpen: false
  };

  toggleMainMenu() {
    this.set({
      mainMenuOpen: !this.state.mainMenuOpen
    });
  }

  openMainMenu() {
    this.set({
      mainMenuOpen: true
    });
  }

  closeMainMenu() {
    this.set({
      mainMenuOpen: false
    });
  }
}

const { actions, store } = createRefluxStore(AppState);

export const AppStateStore = store;
export const AppStateActions = actions;



// WEBPACK FOOTER //
// ./src/js/entities/AppState.js